import React, { useState, useRef, useEffect } from "react";
import settingsImg from "../../Assets/Images/settings-preview.svg";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
const ShopifyCollectionPreviewSlider = ({
  list,
  updateOpenArrayState,
  sectionId,
  title,
  template,
  image,
}) => {
  const spanStyle = {
    padding: "10px",
    background: "#efefef",
    color: "#000000",
    width: "50%",
    textAlign: "center",
  };
  const divStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    height: "160px",
    borderRadius: "7px",
    border: "1px solid #e6e7e8",
    marginRight: "0.4rem",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  const handleClickSection = () => {
    updateOpenArrayState(sectionId);
  };
  const [selectedImage, setSelectedImage] = useState(list[0]?.images[0]?.src);

  return (
    <div className="mt-3 containerPreviewRichText">
      {template === "WithBackground" ? (
        <div
          className="bg-slider pb-2"
          style={{
            backgroundImage: `url(${image})`,
          }}
        >
          <div className="mb-2 pt-20"></div>
          <div className="slide-container">
            <Slide slidesToShow={2} arrows={false} duration={2000000}>
              {list.map((slideImage, index) => (
                <div key={index} arrows={false}>
                  <div className="bg-white mx-1 px-1 rounded-top">
                    <p
                      style={{
                        color: "#101010",
                        fontsize: 13 + "px",
                        height: "43px",
                        overflow: "hidden",
                      }}
                    >
                      {slideImage.title ? slideImage.title : ""}
                    </p>
                    <div
                      className="sliders mb-2"
                      style={{
                        ...divStyle,
                        backgroundImage: `url(${
                          slideImage.images[0]?.src
                            ? slideImage.images[0]?.src
                            : ""
                        })`,
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </Slide>
          </div>
        </div>
      ) : template === "Calendar" ? (
        <div>
          <div className="calendar-zone rounded ms-3 p-2 bg-white py-3 slide-container d-flex flex-column">
            <div className="mb-2">
              <b style={{ color: "#101010", fontsize: 16 + "px" }}>
                {title && title.toUpperCase()}
              </b>
            </div>
            <div className="d-flex justify-content-between">
              <div className="calendar w-33 position-relative">
                <p className="position-absolute upper">
                  {new Date().toLocaleString("default", { month: "short" })}
                </p>
                <p className="position-absolute">{new Date().getDate()}</p>
              </div>
              <div className="w-66">
                <Slide slidesToShow={2} arrows={false} duration={2000000}>
                  {list.map((slideImage, index) => (
                    <div key={index} arrows={false}>
                      <div
                        className="mb-2"
                        style={{
                          ...divStyle,
                          backgroundImage: `url(${
                            slideImage.images[0]?.src
                              ? slideImage.images[0]?.src
                              : ""
                          })`,
                        }}
                      ></div>
                      {/* <p style={{ color: "#101010", fontsize: 13 + "px" }}>
                    {slideImage.title ? slideImage.title : ""}
                  </p> */}
                    </div>
                  ))}
                </Slide>
              </div>
            </div>
          </div>
        </div>
      ) : template === "Slider" ? (
        <div className="max-w-xl mx-auto text-center">
          <img
            src={selectedImage}
            alt="Main Display"
            className="w-full h-auto rounded-xl shadow-lg"
            style={{
              minHeight: "200px",
              maxh: "200px",
              width: "100%",
              // objectFit: "none",
              // objectPosition: "center",
            }}
          />
          <Swiper
            slidesPerView={4}
            spaceBetween={40}
            freeMode={true}
            navigation={false}
            modules={[Navigation, FreeMode, Thumbs]}
            className="mt-2"
          >
            <div className="rowDiv mt-2 full overflow-x-auto">
              {list.map((item, index) => (
                <SwiperSlide key={index}>
                  <img
                    key={index}
                    src={item?.images[0]?.src ? item?.images[0]?.src : ""}
                    style={{
                      height: "120px",
                      width: "80px",
                      // objectFit: "none",
                      // objectPosition: "center",
                      cursor: "pointer",
                    }}
                    // className={`w-20 h-16 rounded-lg cursor-pointer transition-transform ${
                    //   selectedImage === item
                    //     ? "ring-2 ring-blue-500 scale-105"
                    //     : ""
                    // }`}
                    onClick={() => setSelectedImage(item?.images[0]?.src)}
                  />
                </SwiperSlide>
              ))}
            </div>
          </Swiper>
        </div>
      ) : (
        // </div>
        <div>
          <div className="mb-2">
            <b style={{ color: "#101010", fontsize: 16 + "px" }}>
              {title && title.toUpperCase()}
            </b>
          </div>
          <div className="slide-container">
            <Slide slidesToShow={2} arrows={false} duration={2000000}>
              {list.map((slideImage, index) => (
                <div key={index} arrows={false}>
                  <div
                    className="mb-2"
                    style={{
                      ...divStyle,
                      backgroundImage: `url(${
                        slideImage.images[0]?.src
                          ? slideImage.images[0]?.src
                          : ""
                      })`,
                    }}
                  ></div>
                  <p style={{ color: "#101010", fontsize: 13 + "px" }}>
                    {slideImage.title ? slideImage.title : ""}
                  </p>
                </div>
              ))}
            </Slide>
          </div>
        </div>
      )}

      {/* <div className="slide-container mx-1">
        <div className="d-flex justify-content-between align-items-center">
          <div className="">
            <b style={{ color: "#101010", fontsize: 16 + "px" }}>
              {title.toUpperCase()}
            </b>
          </div>
        </div>
        <Slide
          transitionDuration={200}
          duration={100000}
          arrows={false}
          slidesToShow={2}
        >
          <div className="d-flex mt-2">
            {map((slideImage, index) => (
              <div className="mx-1 w-50" key={index}>
                <div className="border-grey">
                  <img
                    className="d-inline-flex"
                    style={{
                      width: "100" + "%",
                      height: 165 + "px",

                      backgroundImage: `url(${
                        slideImage.images[0]?.src
                          ? slideImage.images[0].src
                          : placeHolderImg
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    alt=""
                  />
                </div>
                <p style={{ color: "#101010", fontsize: 13 + "px" }}>
                  {slideImage.title ? slideImage.title : ""}
                </p>
              </div>
            ))}
          </div>
        </Slide>
      </div> */}

      <div className="overlay4" onClick={handleClickSection}>
        <img src={settingsImg} />
      </div>
    </div>
  );
};

export default ShopifyCollectionPreviewSlider;
